"use strict";

exports.__esModule = true;
exports.isSmallScreen = isSmallScreen;
function isSmallScreen() {
  return window.matchMedia && !window.matchMedia("(min-width: 380px)").matches;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/auth0-lock/lib/utils/media_utils.js
 ** module id = 196
 ** module chunks = 0
 **/